import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7b5a43e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { nextTick, onMounted, onUnmounted, ref } from 'vue';

import { gsap } from 'gsap';
import SplitText from 'gsap/SplitText';
import useResize from '@/composables/useResize';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeroTitle',
  props: {
    title: {},
    show: { type: Boolean }
  },
  setup(__props: any) {

gsap.registerPlugin(SplitText);


const props = __props;

const root = ref<HTMLElement>()
let textSplited: SplitText = null;
let textSplitedParent: SplitText = null;

const onResize = async () => {
  if (textSplited || textSplitedParent) {
    textSplitedParent.revert()
    textSplited.revert()
  }

  await nextTick()
  
  textSplited = new SplitText(root.value, { type: 'lines', linesClass: 'Line' });
  textSplitedParent = new SplitText(root.value, { type: 'lines', linesClass: 'Line__Parent' });
}

const { registerResize, unregisterResize } = useResize();

onMounted(() => {
  onResize()
  registerResize(onResize)
})

onUnmounted(() => {
  unregisterResize();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h2", {
    class: _normalizeClass(["Title", { 'show': _ctx.show }]),
    innerHTML: _ctx.title,
    ref_key: "root",
    ref: root
  }, null, 10, _hoisted_1))
}
}

})